import u from "styled-components";
import { Base as a } from "./atoms-v2777.js";
import { blendCssColors as r } from "./atoms-v255.js";
const t = ({ size: n, theme: i }) => {
  var o, l, s;
  switch (n) {
    case "large":
      return (o = i == null ? void 0 : i.get("tokens.body.compact-expressive")) == null ? void 0 : o.toJS();
    case "medium":
      return (l = i == null ? void 0 : i.get("tokens.body.compact-productive")) == null ? void 0 : l.toJS();
    case "small":
      return (s = i == null ? void 0 : i.get("tokens.helper.productive")) == null ? void 0 : s.toJS();
    default:
      return {
        fontSize: "inherit",
        fontWeight: "inherit",
        letterSpacing: "inherit",
        lineHeight: "inherit"
      };
  }
}, $ = u.a`
  ${a}
  ${({ $size: n, theme: i }) => t({ size: n, theme: i })}

  align-items: center;
  color: ${({ $colorTheme: n, $disabled: i, theme: o }) => i ? o == null ? void 0 : o.get(`ui.link.${n}.disabled`) : o == null ? void 0 : o.get(`ui.link.${n}.text`)};
  cursor: pointer;
  display: ${({ $hasIcon: n }) => n ? "inline-flex" : "inline"};
  pointer-events: ${({ $disabled: n }) => n ? "none" : "auto"};
  text-decoration-thickness: 1px;
  text-underline-offset: 0.2em;

  &:hover {
    color: ${({ $colorTheme: n, theme: i }) => r(
  i == null ? void 0 : i.get(`ui.link.${n}.hover`),
  i == null ? void 0 : i.get(`ui.link.${n}.text`)
)};
  }

  &:focus {
    outline: 1px solid ${({ $colorTheme: n, theme: i }) => i == null ? void 0 : i.get(`ui.link.${n}.focus`)};
    outline-offset: 1px;
    text-decoration: none;
  }

  & i {
    color: ${({ $colorTheme: n, $disabled: i, theme: o }) => i ? o == null ? void 0 : o.get(`ui.link.${n}.disabled`) : o == null ? void 0 : o.get(`ui.link.${n}.items`)};
    transform: translateY(-0.1em);
    vertical-align: middle;
  }

  &:hover i {
    color: ${({ $colorTheme: n, theme: i }) => r(
  i == null ? void 0 : i.get(`ui.link.${n}.hover`),
  i == null ? void 0 : i.get(`ui.link.${n}.items`)
)};
  }
`, p = u.button`
  ${a}
  ${({ $size: n, theme: i }) => t({ size: n, theme: i })}

  all: unset;
  /* stylelint-disable-next-line order/properties-alphabetical-order */
  align-items: center;
  color: ${({ $colorTheme: n, $disabled: i, theme: o }) => i ? o == null ? void 0 : o.get(`ui.link.${n}.disabled`) : o == null ? void 0 : o.get(`ui.link.${n}.text`)};
  cursor: pointer;
  display: ${({ $hasIcon: n }) => n ? "inline-flex" : "inline"};
  pointer-events: ${({ $disabled: n }) => n ? "none" : "auto"};
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 0.2em;

  &:hover {
    color: ${({ $colorTheme: n, theme: i }) => r(
  i == null ? void 0 : i.get(`ui.link.${n}.hover`),
  i == null ? void 0 : i.get(`ui.link.${n}.text`)
)};
  }

  &:focus-visible {
    outline: 1px solid ${({ $colorTheme: n, theme: i }) => i == null ? void 0 : i.get(`ui.link.${n}.focus`)};
    outline-offset: 1px;
    text-decoration: none;
  }

  & i {
    color: ${({ $colorTheme: n, $disabled: i, theme: o }) => i ? o == null ? void 0 : o.get(`ui.link.${n}.disabled`) : o == null ? void 0 : o.get(`ui.link.${n}.items`)};
    transform: translateY(-0.1em);
    vertical-align: middle;
  }

  &:hover i {
    color: ${({ $colorTheme: n, theme: i }) => r(
  i == null ? void 0 : i.get(`ui.link.${n}.hover`),
  i == null ? void 0 : i.get(`ui.link.${n}.items`)
)};
  }
`;
export {
  p as Button,
  $ as Link
};
